<template>
  <div class="view">
    <h2 class="ui inverted header">Registration</h2>
    <div class="">
      <sui-message size="large">
        A verificaition link has been sent to your email address.<br>
        Open it up to activate your account.
      </sui-message>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AccountRegisterStart'
  }
</script>

<style scoped>
  .view { display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; }
</style>
